import { access_to_medication } from '@App/data/benefits.json';
import { VisualizationBoxItems } from '@App/data/VisualizationBoxItems';
import { usePrescriptionStore } from '@App/stores';
import { Features } from '@Config/Features';
import { path, Routes } from '@Config/Routes';
import { InsuranceType } from '@Framework/constants/InsuranceType';
import { useFeature } from '@Framework/hooks/useFeature';
import { useTreatments } from '@Framework/hooks/useTreatments';
import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { OdsLayout } from '../../../layouts/odsLayout';
import { BenefitBox } from '../../../molecules/BenefitBox/BenefitBox';
import { PrimaryAlert } from '../../../molecules/PrimaryAlert';
import { RadioSelect } from '../../../molecules/RadioSelect/RadioSelect';
import { VisualizationBox } from '../../../molecules/VisualizationBox/VisualizationBox';
import { ListBox } from '../../../organisms/ListBox/ListBox';

const faqs: string[] = [
  'Wählen Sie Ihre Versicherungsart und Ihren gewünschten Online-Arzt aus.',
  'Beantworten Sie im Rahmen einer digitalen Anamnese wichtige Fragen zu Ihrer Gesundheit.',
  'Die Ärzte bearbeiten Ihre Anfrage, empfehlen Ihnen nächste Schritte und stellen - falls medizinisch sinnvoll - ein Privatrezept aus. Im Falle von offenen Rückfragen kontaktieren die Ärzte Sie direkt.',
  'Bekommen Sie Ihr Medikament in 1-2 Werktagen von SHOP APOTHEKE versandkostenfrei<sup>8</sup> geliefert oder holen Sie es in einer Apotheke vor Ort ab.'
];

type AccessToMedicationDescription = {
  header: string;
  text: string;
};

const SelectionPage: React.FunctionComponent = () => {
  const benefits = access_to_medication['unknown'];
  const navigate = useNavigate();
  const treatments = useTreatments();
  const { prescriptionType, setIndication, setPrescriptionType, setIndicationPrice } = usePrescriptionStore(
    ({ prescriptionType, setIndication, setPrescriptionType, setIndicationPrice }) => ({
      prescriptionType,
      setIndication,
      setPrescriptionType,
      setIndicationPrice
    })
  );
  const isQuestionnaireVisualizationFeatureActive = useFeature(Features.questionnaireVisualization);

  const search = useLocation().search;
  const service = new URLSearchParams(search).get('serviceId');

  useEffect(() => {
    const selectedIndication = treatments?.find(entry => entry.service === service);

    if (selectedIndication) {
      setIndication(selectedIndication.text);
      setIndicationPrice(selectedIndication.price);
    }
  }, [treatments]);

  // Preselection public insurance
  if (prescriptionType === undefined) {
    setPrescriptionType(InsuranceType.PUBLIC);
  }

  const child1: React.ReactElement = (
    <RadioSelect
      labelPrivate={'Ich bin privat versichert'}
      labelPublic={'Ich bin gesetzlich versichert'}
      title="Wie sind Sie versichert?"
      label="Weiter"
      value={prescriptionType}
      onButtonClick={() => navigate(path(`${Routes.ACCESS_TO_MEDICATION}/${prescriptionType}`))}
      onChange={prescriptionType => setPrescriptionType(prescriptionType)}
    />
  );

  const child2: React.ReactElement = (
    <>
      {prescriptionType === InsuranceType.PUBLIC && (
        <Box pb={2.5}>
          <PrimaryAlert
            showIcon
            text="Patienten einer gesetzlichen Krankenversicherung können den Online-Arzt-Service als Selbstzahler nutzen. Dabei wird eine Behandlungsgebühr von 9 - 29 € erhoben."
          />
        </Box>
      )}
      {isQuestionnaireVisualizationFeatureActive ? (
        <VisualizationBox title="So funktioniert's" items={VisualizationBoxItems} />
      ) : (
        <ListBox title="Benötigen Sie Hilfe?" subtitle="So funktioniert's" elements={faqs} />
      )}
      {!prescriptionType && (
        <Box pt={2.5}>
          <PrimaryAlert text="* Kostenübernahme für privatversicherte Patienten. Patienten einer gesetzlichen Krankenversicherung können den Online-Arzt-Service als Selbstzahler nutzen." />
        </Box>
      )}
    </>
  );

  return <OdsLayout children1={child1} children2={child2} />;
};

export { SelectionPage };
